import { debounce } from "lodash-es";
import { useEffect } from "react";

export function useResizeObserver(
  element: HTMLElement | null,
  callback: (element: HTMLElement | null) => void,
  debounceTime: number = 200,
) {
  useEffect(() => {
    if (element) {
      const handleResize = debounce(() => callback(element), debounceTime);

      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(element);

      return () => {
        resizeObserver.unobserve(element);
      };
    } else {
      callback(null);
    }
  }, [element, callback, debounceTime]);
}
